// Pfade: /app/jahresabschluss (Firmenwahl), /app/jahresabschluss/<Firma>
export const jaPath = (clientId?: string) => (clientId ? `/app/jahresabschluss/${clientId}` : '/app/jahresabschluss');
